import {createFileRoute, stripSearchParams} from '@tanstack/react-router'
import {type} from 'arktype/internal/keywords/keywords.ts'

import {fallbackToDefault} from '@/utils/schema/fallback'
import searchParamString from '@/utils/schema/searchParamString'

const DEFAULT_VALUES = {
  guest: false,
  failed: false,
  flightId: '',
  bookingId: '',
}

const flightCheckoutSearchSchema = type({
  bookingId: searchParamString.optional(),
  flightId: searchParamString.optional(),
  guest: fallbackToDefault(type.boolean, DEFAULT_VALUES.guest),
  failed: fallbackToDefault(type.boolean, DEFAULT_VALUES.failed),
})

export const Route = createFileRoute('/flights/checkout/')({
  validateSearch: flightCheckoutSearchSchema,
  search: {
    middlewares: [stripSearchParams(DEFAULT_VALUES)],
  },
})
